export default __webpack_public_path__ + "static/media/movies.929557ce.png";